export default __webpack_public_path__ + "static/spacing-tokens-dark-d1d73e8018af5d03e2cbe96c4ba63b28.png";